var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TablaStructure',{attrs:{"ruta":_vm.ruta,"sincEnterprise":_vm.sincEnterprise,"nombreItem":_vm.nombreItem,"nombreId":_vm.nombreId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }